import { Routes } from "@angular/router";
import { LoginComponent } from "./auth/login/login/login.component";
import { MainComponent } from "./main/main.component";
import { authGuard } from "./auth/auth.guard";
import { roleRedirectGuard } from "./auth/role-redirect.guard";
import { SignupComponent } from "./auth/signup/signup/signup.component";
import { FieldClaimComponent } from "./field-claim/field-claim.component";
import { managerGuard } from "./auth/manager.guard";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./auth/reset-password/reset-password/reset-password.component";
import { ManagerDashboardComponent } from "./dashboard/manager-dashboard/manager-dashboard.component";
import { growerGuard } from "./auth/grower.guard";
import { GrowerDashboardComponent } from "./dashboard/grower-dashboard/grower-dashboard.component";
import { FieldClaimManagerComponent } from "./field-claim/field-claim-manager/field-claim-manager.component";
import { StatisticsManagerDashboardComponent } from "./dashboard/manager-dashboard/statistics-manager-dashboard/statistics-manager-dashboard.component";
import { FieldClaimEntityComponent } from "./field-claim/field-claim-entity/field-claim-entity.component";
import { entityGuard } from "./auth/entity.guard";
import { EntityDashboardComponent } from "./dashboard/entity-dashboard/entity-dashboard.component";
import { NotFoundError } from "./error/not-found-error/not-found-error";
import { ExpiredError } from "./error/expired-error/expired-error";
import { demoModeGuard } from "./auth/demo.guard";
import { UserManagementComponent } from "./dashboard/manager-dashboard/user-management/user-management.component";
import { Admin } from "./admin/admin";
import { adminGuard } from "./auth/admin.guard";
import { FieldConfigDashboard } from "./dashboard/manager-dashboard/field-config-dashboard/field-config-dashboard";

export const PATH = {
  login: "login",
  signup: "signup",
  forgotPassword: "forgot-password",
  resetPassword: "reset-password",
  main: "",
  managerDashboard: "manager/dashboard",
  managerDashboardV1: "manager/dashboard-v1",
  managerFieldsView: "manager/fields-view",
  managerMapView: "manager/map-view",
  entityFieldsView: "entity/fields-view",
  entityMapView: "entity/map-view",
  growerDashboard: "dashboard",
  field: "field",
  userManagement: "manager/user-management",
  admin: "admin",
  fieldConfig: "manager/field-config",
} as const;

export const routes: Routes = [
  { path: PATH.login, component: LoginComponent },
  { path: PATH.signup, component: SignupComponent },
  { path: PATH.forgotPassword, component: ForgotPasswordComponent },
  { path: PATH.resetPassword, component: ResetPasswordComponent },
  {
    path: PATH.main,
    component: MainComponent,
    canActivate: [authGuard, roleRedirectGuard, demoModeGuard], // , roleRedirectGuard
    children: [
      {
        path: PATH.managerDashboard,
        component: StatisticsManagerDashboardComponent,
        canActivate: [managerGuard],
      },
      {
        path: PATH.managerFieldsView,
        component: ManagerDashboardComponent,
        canActivate: [managerGuard],
      },
      {
        path: PATH.entityFieldsView,
        component: EntityDashboardComponent,
        canActivate: [entityGuard],
      },
      {
        path: PATH.managerMapView,
        component: FieldClaimManagerComponent,
        canActivate: [managerGuard],
      },
      {
        path: PATH.userManagement,
        component: UserManagementComponent,
        canActivate: [authGuard],
      },
      {
        path: PATH.fieldConfig,
        component: FieldConfigDashboard,
        canActivate: [authGuard],
      },
      {
        path: PATH.entityMapView,
        component: FieldClaimEntityComponent,
        canActivate: [entityGuard],
      },
      {
        path: PATH.growerDashboard,
        component: GrowerDashboardComponent,
        canActivate: [growerGuard],
      },
      {
        path: PATH.field,
        component: FieldClaimComponent,
        canActivate: [growerGuard],
      },
      { path: PATH.admin, component: Admin, canActivate: [adminGuard] },
    ],
  },
  { path: "invalid-expired-token", component: ExpiredError },
  { path: "**", component: NotFoundError, pathMatch: "full" },
];
